import React, { useEffect, useState } from 'react';
import api from '../../api';

function AdminDashboard() {
  const [stats, setStats] = useState({ gallery: 0, messages: 0, unread: 0, sections: 0 });

  useEffect(() => {
    Promise.all([
      api.get('/gallery/admin'),
      api.get('/contact'),
      api.get('/content'),
    ]).then(([gal, msg, cnt]) => {
      const messages = msg.data;
      setStats({
        gallery: gal.data.length,
        messages: messages.length,
        unread: messages.filter(m => !m.read).length,
        sections: Object.keys(cnt.data).length,
      });
    }).catch(() => {});
  }, []);

  return (
    <>
      <div className="admin-topbar"><h1>Dashboard</h1></div>
      <div className="admin-content">
        <div className="admin-stats">
          <div className="stat-card">
            <div className="icon green"><span className="material-icons">photo_library</span></div>
            <div className="number">{stats.gallery}</div>
            <div className="label">Fotos en galería</div>
          </div>
          <div className="stat-card">
            <div className="icon blue"><span className="material-icons">mail</span></div>
            <div className="number">{stats.messages}</div>
            <div className="label">Mensajes recibidos</div>
          </div>
          <div className="stat-card">
            <div className="icon red"><span className="material-icons">mark_email_unread</span></div>
            <div className="number">{stats.unread}</div>
            <div className="label">Mensajes sin leer</div>
          </div>
          <div className="stat-card">
            <div className="icon gold"><span className="material-icons">edit_note</span></div>
            <div className="number">{stats.sections}</div>
            <div className="label">Secciones de contenido</div>
          </div>
        </div>
        <div className="admin-card">
          <h3>Bienvenido al Panel Administrativo</h3>
          <p style={{ color: 'var(--text-light)', lineHeight: 1.8 }}>
            Desde aquí puede gestionar todo el contenido de la página web del Liceo Adolfo León Gómez:
          </p>
          <ul style={{ color: 'var(--text-light)', lineHeight: 2, marginTop: '0.5rem', paddingLeft: '1.5rem' }}>
            <li><strong>Contenido:</strong> Edite los textos de todas las secciones de la página (inicio, nosotros, niveles, contacto, etc.)</li>
            <li><strong>Galería:</strong> Suba, edite y organice las fotos que aparecen en la galería</li>
            <li><strong>Mensajes:</strong> Lea los mensajes enviados desde el formulario de contacto</li>
          </ul>
        </div>
      </div>
    </>
  );
}

export default AdminDashboard;
